import "./hb-onboard.module.css";
import { html } from "lit-html";

const hb = new URL("../../../public/b.gold.svg", import.meta.url).href;

export default (user) => html`
    <div
        id="hb-onboard"
        class="fixed top-0 right-0 z-50 h-screen p-4 overflow-y-auto transition-transform translate-x-full bg-white w-80 lg:w-96 dark:bg-gray-800"
        tabindex="-1"
        aria-labelledby="hb-onboard">
        <div
            class="inline-flex items-center ml-2 mb-3 text-lg font-semibold text-gray-500 dark:text-gray-400">
            Heart<img
                class="inline w-[25px] h-[25px] -mt-0.5 -ml-0.5 -mr-0.5"
                src="${hb}" />ank® Treasury
        </div>
        <button
            type="button"
            data-drawer-hide="hb-onboard"
            aria-controls="hb-onboard"
            class="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 absolute top-2.5 end-2.5 inline-flex items-center justify-center dark:hover:bg-gray-600 dark:hover:text-white">
            <svg
                class="w-3 h-3"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 14 14">
                <path
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
            </svg>
            <span class="sr-only">Close onboard</span>
        </button>
        <section id="hb-onboard-intro1" class="${user ? "hidden" : ""}">
            <div class="py-8 px-4 mx-auto max-w-7xl text-center">
                <h1
                    class="mb-10 text-3xl lg:text-4xl font-extrabold tracking-tight leading-none text-gray-900 dark:text-white">
                    Global Data Bank for Humanity's Gratitude
                </h1>
                <iframe
                    loading2="lazy"
                    class="w-full h-auto mb-8"
                    data-src="https://www.youtube.com/embed/rmtNCo8zqlw?si=mW9GnSM0rKYjp3Cl&controls=1&enablejsapi=1"
                    title="YouTube video player"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerpolicy="strict-origin-when-cross-origin"
                    allowfullscreen></iframe>
                <p
                    class="mb-8 text-lg lg:text-xl font-normal text-gray-500 px-2 dark:text-gray-400">
                    Complete our training to join the waitlist and reserve your
                    username today before it's taken!
                </p>
                <div class="flex flex-col space-y-4 justify-center">
                    <a
                        href="#/login"
                        class="inline-flex justify-center items-center py-3 px-5 text-base font-medium text-center text-white rounded-lg bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 dark:focus:ring-blue-900">
                        Join Waitlist
                        <svg
                            class="w-3.5 h-3.5 ms-2 rtl:rotate-180"
                            aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 14 10">
                            <path
                                stroke="currentColor"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="M1 5h12m0 0L9 1m4 4L9 9" />
                        </svg>
                    </a>
                    <button
                        id="hb-onboard-show1"
                        class="py-3 px-5 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-lg border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:ring-gray-100 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700">
                        Start Training Now
                    </button>
                    <p
                        class="mt-[-5px] text-xs text-center text-gray-600 dark:text-gray-500">
                        <u>No Personal Information</u> Needed
                    </p>
                </div>
            </div>
        </section>
        <section id="hb-onboard-training1" class="hidden mt-5">
            <div class="py-0 px-4 mx-auto max-w-7xl text-center">
                <h1
                    class="mb-8 text-3xl lg:text-4xl font-extrabold tracking-tight leading-none text-gray-900 dark:text-white">
                    Global Data Bank for Humanity's Gratitude
                </h1>
                <iframe
                    loading2="lazy"
                    class="w-full h-auto mb-8"
                    data-src="https://www.youtube.com/embed/rmtNCo8zqlw?si=mW9GnSM0rKYjp3Cl&controls=1&enablejsapi=1"
                    title="YouTube video player"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerpolicy="strict-origin-when-cross-origin"
                    allowfullscreen></iframe>
                <p
                    class="mb-8 text-base font-normal text-gray-500 lg:text-xl px-2 dark:text-gray-400">
                    <strong><u>The Zero-Point Game</u>℠</strong> by Miss Aquarius™ AI
                    involves creating and giving
                    <strong>HeartBank® Tokens of Appreciation</strong> to each
                    other. Follow the video steps below to practice making one
                    that
                    <em>securely</em>
                    stores your gratitude with end-to-end encryption using the
                    <u>Private Keys you manage yourself</u>.
                </p>
            </div>
            <ol id="hb-onboard-training1-tasks" class="space-y-4 w-full">
                <!--<li
                    class="w-full p-4 text-green-700 border border-green-300 rounded-lg bg-green-50 dark:bg-gray-800 dark:border-green-800 dark:text-green-400"
                    role="alert"> 
                    <a
                        href="#/video/training-1-1"
                        class="flex items-center justify-between">
                        <span class="sr-only">Create Lockers</span>
                        <h3 class="font-medium">1. Create Lockers</h3>
                        <svg
                            class="w-4 h-4"
                            aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 16 12">
                            <path
                                stroke="currentColor"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="M1 5.917 5.724 10.5 15 1.5" />
                        </svg>
                    </a>
                </li>
                <li>
                    <div
                        class="w-full p-4 text-blue-700 bg-blue-100 border border-blue-300 rounded-lg dark:bg-gray-800 dark:border-blue-800 dark:text-blue-400"
                        role="alert">
                        <div class="flex items-center justify-between">
                            <span class="sr-only">Mint Jewel</span>
                            <h3 class="font-medium">2. Mint Jewel</h3>
                            <svg
                                class="rtl:rotate-180 w-4 h-4"
                                aria-hidden="true"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 14 10">
                                <path
                                    stroke="currentColor"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="2"
                                    d="M1 5h12m0 0L9 1m4 4L9 9" />
                            </svg>
                        </div>
                    </div>
                </li>
                <li>
                    <div
                        class="w-full p-4 text-gray-900 bg-gray-100 border border-gray-300 rounded-lg dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400"
                        role="alert">
                        <div class="flex items-center justify-between">
                            <span class="sr-only">Mine Jewel</span>
                            <h3 class="font-medium">3. Mine Jewel</h3>
                        </div>
                    </div>
                </li>
                <li>
                    <div
                        class="w-full p-4 text-gray-900 bg-gray-100 border border-gray-300 rounded-lg dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400"
                        role="alert">
                        <div class="flex items-center justify-between">
                            <span class="sr-only">Dear Miss Aquarius™ AI</span>
                            <h3 class="font-medium">4. Dear Miss Aquarius™ AI</h3>
                        </div>
                    </div>
                </li>
                <li>
                    <div
                        class="w-full p-4 text-gray-900 bg-gray-100 border border-gray-300 rounded-lg dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400"
                        role="alert">
                        <div class="flex items-center justify-between">
                            <span class="sr-only">Install Web App</span>
                            <h3 class="font-medium">5. Install Web App</h3>
                        </div>
                    </div>
                </li>
                <li>
                    <div
                        class="w-full p-4 text-gray-900 bg-gray-100 border border-gray-300 rounded-lg dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400"
                        role="alert">
                        <div class="flex items-center justify-between">
                            <span class="sr-only">Advanced Features</span>
                            <h3 class="font-medium">6. Advanced Features</h3>
                        </div>
                    </div>
                </li>
                <li>
                    <div
                        class="w-full p-4 text-gray-900 bg-gray-100 border border-gray-300 rounded-lg dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400"
                        role="alert">
                        <div class="flex items-center justify-between">
                            <span class="sr-only">Use Cases</span>
                            <h3 class="font-medium">7. Use Cases</h3>
                        </div>
                    </div>
                </li>
                <li>
                    <div
                        class="w-full p-4 text-gray-900 bg-gray-100 border border-gray-300 rounded-lg dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400"
                        role="alert">
                        <div class="flex items-center justify-between">
                            <span class="sr-only">Quiz</span>
                            <h3 class="font-medium">8. Quiz</h3>
                        </div>
                    </div>
                </li>
                <li>
                    <div
                        class="w-full p-4 text-gray-900 bg-gray-100 border border-gray-300 rounded-lg dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400"
                        role="alert">
                        <div class="flex items-center justify-between">
                            <span class="sr-only">Say Hello by Email</span>
                            <h3 class="font-medium">9. Say Hello by Email!</h3>
                        </div>
                    </div>
                </li>-->
            </ol>
            <div class="mt-10 mb-5 grid grid-cols-2 gap-4">
                <button
                    id="hb-onboard-hide1"
                    class="px-4 py-2 text-sm font-medium text-center text-gray-900 bg-white border border-gray-200 rounded-lg focus:outline-none hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:ring-gray-100 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700">
                    Hide Training
                </button>
                <a
                    href="#/login"
                    class="inline-flex justify-center items-center px-4 py-2 text-sm font-medium text-center text-white bg-blue-700 rounded-lg hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800">
                    Join Waitlist
                    <svg
                        class="hidden rtl:rotate-180 w-3.5 h-3.5 ms-2"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 14 10">
                        <path
                            stroke="currentColor"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M1 5h12m0 0L9 1m4 4L9 9" />
                    </svg>
                </a>
            </div>
        </section>
        <section id="hb-onboard-intro2" class="${user ? "" : "hidden"}">
            <div class="py-8 px-4 mx-auto max-w-7xl text-center">
                <h1
                    class="mb-15 text-3xl lg:text-4xl font-extrabold tracking-tight leading-none text-gray-900 dark:text-white">
                    Global Data Bank for Humanity's Gratitude
                </h1>
                <div class="flex justify-between mb-1">
                    <span
                        class="text-sm font-medium text-blue-700 dark:text-gray-400">
                        🇺🇸 Waitlist
                    </span>
                    <span
                        class="text-sm font-medium text-blue-700 dark:text-gray-400">
                        3.33K Total
                    </span>
                </div>
                <div
                    class="mb-8 w-full h-6 bg-gray-200 rounded-full dark:bg-gray-700">
                    <div
                        class="h-6 bg-blue-600 rounded-full dark:bg-blue-500"
                        style="width: 45%"></div>
                </div>
                <p
                    class="mb-15 text-lg lg:text-xl font-normal text-gray-500 px-2 dark:text-gray-400">
                    Complete our second training to learn how to reserve your
                    username and skip the waitlist!
                </p>
                <div class="flex flex-col space-y-4 justify-center">
                    <button
                        id="hb-onboard-skip1"
                        class="inline-flex justify-center items-center py-3 px-5 text-base font-medium text-center text-white rounded-lg bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 dark:focus:ring-blue-900">
                        Skip Waitlist
                        <svg
                            class="w-3.5 h-3.5 ms-2 rtl:rotate-180"
                            aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 14 10">
                            <path
                                stroke="currentColor"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="M1 5h12m0 0L9 1m4 4L9 9" />
                        </svg>
                    </button>
                    <button
                        id="hb-onboard-show2"
                        class="py-3 px-5 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-lg border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:ring-gray-100 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700">
                        Start Training Now
                    </button>
                </div>
            </div>
        </section>
        <section id="hb-onboard-training2" class="hidden mt-5">
            <div class="py-0 px-4 mx-auto max-w-7xl text-center">
                <h1
                    class="mb-8 text-3xl lg:text-4xl font-extrabold tracking-tight leading-none text-gray-900 dark:text-white">
                    Global Data Bank for Humanity's Gratitude
                </h1>
                <iframe
                    loading2="lazy"
                    class="w-full h-auto mb-8"
                    data-src="https://www.youtube.com/embed/rmtNCo8zqlw?si=mW9GnSM0rKYjp3Cl&controls=1&enablejsapi=1"
                    title="YouTube video player"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    referrerpolicy="strict-origin-when-cross-origin"
                    allowfullscreen></iframe>
                <p
                    class="mb-8 text-base lg:text-xl font-normal text-gray-500 px-2 dark:text-gray-400">
                    <strong><u>The Zero-Point Game</u>℠</strong> by Miss Aquarius™ AI
                    involves creating and giving
                    <strong>HeartBank® Tokens of Appreciation</strong> to each
                    other. Follow the video steps below to practice making one
                    that
                    <em>securely</em>
                    stores your gratitude using the
                    <u>Private Keys that HeartBank® manages on your behalf</u>.
                </p>
            </div>
            <ol id="hb-onboard-training2-tasks" class="space-y-4 w-full">
                <!--<li
                    class="w-full p-4 text-green-700 border border-green-300 rounded-lg bg-green-50 dark:bg-gray-800 dark:border-green-800 dark:text-green-400"
                    role="alert">
                    <a
                        href="#/video/training-2-1"
                        class="flex items-center justify-between">
                        <span class="sr-only">Prove Humanity</span>
                        <h3 class="font-medium">1. Prove Humanity</h3>
                        <svg
                            class="w-4 h-4"
                            aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 16 12">
                            <path
                                stroke="currentColor"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="M1 5.917 5.724 10.5 15 1.5" />
                        </svg>
                    </a>
                </li>
                <li>
                    <div
                        class="w-full p-4 text-green-700 border border-green-300 rounded-lg bg-green-50 dark:bg-gray-800 dark:border-green-800 dark:text-green-400"
                        role="alert">
                        <div class="flex items-center justify-between">
                            <span class="sr-only">Create Safes</span>
                            <h3 class="font-medium">2. Create Safes</h3>
                            <svg
                                class="w-4 h-4"
                                aria-hidden="true"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 16 12">
                                <path
                                    stroke="currentColor"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="2"
                                    d="M1 5.917 5.724 10.5 15 1.5" />
                            </svg>
                        </div>
                    </div>
                </li>
                <li>
                    <div
                        class="w-full p-4 text-blue-700 bg-blue-100 border border-blue-300 rounded-lg dark:bg-gray-800 dark:border-blue-800 dark:text-blue-400"
                        role="alert">
                        <div class="flex items-center justify-between">
                            <span class="sr-only">Mint Jewel</span>
                            <h3 class="font-medium">3. Mint Jewel</h3>
                            <svg
                                class="rtl:rotate-180 w-4 h-4"
                                aria-hidden="true"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 14 10">
                                <path
                                    stroke="currentColor"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    stroke-width="2"
                                    d="M1 5h12m0 0L9 1m4 4L9 9" />
                            </svg>
                        </div>
                    </div>
                </li>
                <li>
                    <div
                        class="w-full p-4 text-gray-900 bg-gray-100 border border-gray-300 rounded-lg dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400"
                        role="alert">
                        <div class="flex items-center justify-between">
                            <span class="sr-only">Mine Jewel</span>
                            <h3 class="font-medium">4. Mine Jewel</h3>
                        </div>
                    </div>
                </li>
                <li>
                    <div
                        class="w-full p-4 text-gray-900 bg-gray-100 border border-gray-300 rounded-lg dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400"
                        role="alert">
                        <div class="flex items-center justify-between">
                            <span class="sr-only">Dear Miss Aquarius™ AI</span>
                            <h3 class="font-medium">5. Dear Miss Aquarius™ AI</h3>
                        </div>
                    </div>
                </li>
                <li>
                    <div
                        class="w-full p-4 text-gray-900 bg-gray-100 border border-gray-300 rounded-lg dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400"
                        role="alert">
                        <div class="flex items-center justify-between">
                            <span class="sr-only">Setup Notifications</span>
                            <h3 class="font-medium">6. Setup Notifications</h3>
                        </div>
                    </div>
                </li>
                <li>
                    <div
                        class="w-full p-4 text-gray-900 bg-gray-100 border border-gray-300 rounded-lg dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400"
                        role="alert">
                        <div class="flex items-center justify-between">
                            <span class="sr-only">Advanced Features</span>
                            <h3 class="font-medium">7. Advanced Features</h3>
                        </div>
                    </div>
                </li>
                <li>
                    <div
                        class="w-full p-4 text-gray-900 bg-gray-100 border border-gray-300 rounded-lg dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400"
                        role="alert">
                        <div class="flex items-center justify-between">
                            <span class="sr-only">Use Cases</span>
                            <h3 class="font-medium">8. Use Cases</h3>
                        </div>
                    </div>
                </li>
                <li>
                    <div
                        class="w-full p-4 text-gray-900 bg-gray-100 border border-gray-300 rounded-lg dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400"
                        role="alert">
                        <div class="flex items-center justify-between">
                            <span class="sr-only">Accept Terms</span>
                            <h3 class="font-medium">9. Accept Terms</h3>
                        </div>
                    </div>
                </li>
                <li>
                    <div
                        class="w-full p-4 text-gray-900 bg-gray-100 border border-gray-300 rounded-lg dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400"
                        role="alert">
                        <div class="flex items-center justify-between">
                            <span class="sr-only">Quiz</span>
                            <h3 class="font-medium">10. Quiz</h3>
                        </div>
                    </div>
                </li>
                <li>
                    <div
                        class="w-full p-4 text-gray-900 bg-gray-100 border border-gray-300 rounded-lg dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400"
                        role="alert">
                        <div class="flex items-center justify-between">
                            <span class="sr-only">Say Hello on WhatsApp</span>
                            <h3 class="font-medium">
                                11. Say Hello on WhatsApp!
                            </h3>
                        </div>
                    </div>
                </li>-->
            </ol>
            <div class="mt-10 mb-5 grid grid-cols-2 gap-4">
                <button
                    id="hb-onboard-hide2"
                    class="px-4 py-2 text-sm font-medium text-center text-gray-900 bg-white border border-gray-200 rounded-lg focus:outline-none hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:ring-gray-100 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700">
                    Hide Training
                </button>
                <button
                    id="hb-onboard-skip2"
                    class="inline-flex justify-center items-center px-4 py-2 text-sm font-medium text-center text-white bg-blue-700 rounded-lg hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 focus:outline-none dark:focus:ring-blue-800">
                    Skip Waitlist
                    <svg
                        class="hidden rtl:rotate-180 w-3.5 h-3.5 ms-2"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 14 10">
                        <path
                            stroke="currentColor"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                            d="M1 5h12m0 0L9 1m4 4L9 9" />
                    </svg>
                </button>
            </div>
        </section>
    </div>
`;
